import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Dropdown, DropdownButton, Form } from 'react-bootstrap';
import windowSize from '../../../util/windowSize';

import Header from '../../../components/Header/Header';
import { OBJECT_ID_REGEX } from '../../../util/pageRules';

import defaultBoardImg from '../../../assets/images/stream-default-icon.jpg'; 

import '../../../components/Header/Header.scss';

export class ValueStreamSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q: ''
    };    
  }

  componentDidMount() {
    const { items, selectedItem, onListAll, user, params } = this.props;
    if (!items || !items.length) {
      if (onListAll) {
        onListAll();
      }
    } else if (
      !selectedItem ||
      !selectedItem._id ||
      _.findIndex(items, { _id: selectedItem._id }) === -1
    ) {
      // If no valid selection, try to select a default
      this.selectDefaultItem(items, params.id, user.config);
    }
  }

  componentDidUpdate(prevProps) {
    const { items, selectedItem, noItems, router, emptyPath, onSelect, params, user, loaded } = this.props;

    if (noItems === true && loaded) {
      router.replace(emptyPath ? `${emptyPath}` : '/no-streams');
      return;
    }

    if (items && prevProps.items !== items) {
      if (items.length > 0) {
        if (
          !selectedItem ||
          !selectedItem._id ||
          _.findIndex(items, { _id: selectedItem._id }) === -1
        ) {
          this.selectDefaultItem(items, params.id, user.config);
        }
      } else if (onSelect) {
        onSelect(undefined); 
      }
    }
  }

  selectDefaultItem(itemsToSearch, paramId, userConfig) {
    const { wallmode, onSelect, router, basePath, location, defaultItemIdFromUserConfigKey } = this.props;

    if (!itemsToSearch || !itemsToSearch.length || !onSelect) {
      return false;
    }

    let found;
    let itemToSelect = itemsToSearch[itemsToSearch.length - 1]; // Default to last item
    
    if (paramId && OBJECT_ID_REGEX.test(paramId)) {
      found = _.find(itemsToSearch, b => b._id === paramId);
      if (found) {
        itemToSelect = found;
      }
    } else if (userConfig && defaultItemIdFromUserConfigKey && userConfig[defaultItemIdFromUserConfigKey]) {
      found = _.find(itemsToSearch, b => b._id === userConfig[defaultItemIdFromUserConfigKey]);
      if (found) {
        itemToSelect = found;
      }
    }
    
    if (!itemToSelect) {
      return;
    }

    if (this.props.applyView && location.query.view) {
      this.props.applyView(itemToSelect._id, location.query.view);
    }

    onSelect(itemToSelect, location.query.view);

    if (basePath && (!paramId || paramId !== itemToSelect._id)) {
        router.push(`${basePath}/${itemToSelect._id}${location.search || ''}`);
    }
  }

  handleItemChange = (item) => {
    const { router, onSelect, onSaveSelected, basePath, location, selectedItem } = this.props;

    // Skip if selecting the same item that's already selected
    if (selectedItem && selectedItem._id === item._id) {
      return;
    }

    if (onSelect) {
      onSelect(item);
    }
    if (onSaveSelected) {
      onSaveSelected(item._id);
    }

    if (basePath) {
      const to = location && location.search !== ''
        ? `${basePath}/${item._id}${location.search}`
        : `${basePath}/${item._id}`;
      router.push(to);
    }
  };

  handleSearch = e => {
    this.setState({ q: e.target.value });
  };

  renderMenuItemContent(item) {
    const { defaultItemImage } = this.props;
    const imageUrl = item.imageUrl 
      ? item.imageUrl 
      : defaultItemImage || defaultBoardImg;

    return (
      <React.Fragment>
        <span className="btn img-dashboard">
          <img src={imageUrl} alt={item.name || "item-icon"} className="no-filter" />
        </span>
        <div className="dropdown-text">
          <p>{item.name}</p>         
          {item.createdBy && !item.updatedBy && <span>Created by: {typeof item.createdBy === 'object' ? item.createdBy.name || item.createdBy.email : item.createdBy}</span>}
          {item.updatedBy && <span>Updated by: {typeof item.updatedBy === 'object' ? item.updatedBy.name || item.updatedBy.email : item.updatedBy}</span>}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { wallmode, items, selectedItem, buttons, searchPlaceholder, dataIsLoading } = this.props;

    if (!items) return null; 

    return (
      <Header
        showTeam={this.props.showTeamInHeader !== undefined ? this.props.showTeamInHeader : true} 
        showSync={false}
        buttons={buttons}
        dashboardSelector={
          <React.Fragment>
            {!wallmode ? (
              <DropdownButton
                className="dropdown-dashboard-list"
                title={selectedItem ? this.renderMenuItemContent(selectedItem) : 'Select an item'}
                id="items-dropdown"
                variant="secondary"
                disabled={!items || items.length === 0}
              >
                <Form.Group controlId="q" className="search-wrap">
                  <Form.Control
                    type="text"
                    name="q"
                    value={this.state.q}
                    onChange={this.handleSearch}
                    placeholder={searchPlaceholder || "Search"}
                  />
                </Form.Group>
                <div className="dropdown-scroll">
                  {items
                    .filter(item => {
                      const name = (item.name || '').toLowerCase();
                      return name.includes(this.state.q.toLowerCase());
                    })
                    .map((item, i) => (
                      <Dropdown.Item
                        key={item._id || i} // Prefer unique _id
                        className={selectedItem && selectedItem._id === item._id ? 'active' : ''}
                        eventKey={item._id || i}
                        onClick={() => this.handleItemChange(item)}
                      >
                        {this.renderMenuItemContent(item)}
                      </Dropdown.Item>
                    ))}
                </div>
              </DropdownButton>
            ) : (
              <div className="title-item">
                {selectedItem && ( 
                  <div className="title-power-up">
                    {this.renderMenuItemContent(selectedItem)}
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        }
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    wallmode: state.app.wallmode,
    user: state.auth.user,
  };
};

export default windowSize(withRouter(connect(mapStateToProps)(ValueStreamSelector)));
